import { connect } from 'react-redux';
import MusicItemShortcodeComponent from '../components/MusicItemShortcodeComponent';
import { getMusicData } from '../actions/MusicsPageActions';

const mapDispatchToProps = (dispatch) => ({
    getMusicData: (artistSlug, musicSlug) => dispatch(getMusicData(artistSlug, musicSlug)),
});
const MusicItemShortcodeContainer = connect(
    null,
    mapDispatchToProps,
)(MusicItemShortcodeComponent);

export default MusicItemShortcodeContainer;
